module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg",
    class: {
      Domfixed: _vm.trueFixed
    },
    attrs: {
      "id": "navLi"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-inner"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    class: {
      active: _vm.nav('homeContent')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("优势介绍")])], 1), _vm._v(" "), _c('li', {
    staticClass: "dropdown",
    class: {
      active: _vm.nav('homeMortgageContent') || _vm.nav('homeReplaceContent') || _vm.nav('homeLoanContent')
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.servIntroNav)), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.servIntroClick(0)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/mortgage"
    }
  }, [_vm._v("仓单质押")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.servIntroClick(1)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/replace"
    }
  }, [_vm._v("代检代发")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.servIntroClick(2)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/loan"
    }
  }, [_vm._v("易木贷(信贷)")])], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "dropdown",
    class: {
      active: _vm.navActive()
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.firmIntroNav)), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.firmIntroClick(0)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/firm-intro"
    }
  }, [_vm._v("公司介绍")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.firmIntroClick(1)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/join-us/market"
    }
  }, [_vm._v("加入我们")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.firmIntroClick(2)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("联系我们")])], 1)])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.nav('homeApp')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/app"
    }
  }, [_vm._v("下载APP")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://mall.emulian.com/"
    }
  }, [_vm._v("木材商城")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81be3b18!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/header/HomeNavigator.vue
// module id = 166
// module chunks = 1